import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer } from "react-toastify";
import StaticFooter from "../common_components/StaticFooter";
import StaticHeader from "../common_components/staticHeader";
import $ from 'jquery'
import '../../../../src/App.css'

class CurrentAwards extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        this.loadscript()
    }
    loadscript() {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });
    }

    render() {
        const { } = this.state;
        return (
            <>
                <StaticHeader />
                <div className="website"></div>
                <StaticFooter />
                <ToastContainer />
            </>
        )
    }
}
export default withRouter(
    connect(null, {})(CurrentAwards)
);
